import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectList: [],
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectList: (state, action) => {
      state.projectList = action.payload.list;
    }
  },
});

export const {
  setProjectList,
} = projectSlice.actions;

export default projectSlice.reducer;